import { Controller } from '@hotwired/stimulus';
import { eventListener } from '@inked/utilities';

export class DialogController extends Controller {
  static targets = ['dialog'];
  static values = {
    modal: {
      default: true,
      type: Boolean,
    },
    open: {
      default: false,
      type: Boolean,
    },
    removeOnClose: {
      default: false,
      type: Boolean,
    },
    triggerSelector: String,
  };

  connect() {
    if (this.openValue) {
      this.open();
    }

    if (this.triggerSelectorValue) {
      this.stopTriggerClickEvents = eventListener(
        this.triggerSelectorValue,
        'click',
        () => this.open(),
      );
    }
  }

  disconnect() {
    if (this.triggerSelectorValue) {
      this.stopTriggerClickEvents();
    }
  }

  open() {
    this.dispatch('beforeopen');

    this.modalValue ? this.dialogTarget.showModal() : this.dialogTarget.show();
  }

  close() {
    this.dispatch('beforeclose');

    this.dialogTarget.close();

    if (this.removeOnCloseValue) {
      this.element.remove();
    }
  }
}
